export default __webpack_public_path__ + "static/media/charge.7681fcaf.png";